import { z } from 'zod';

export enum TaskPriority {
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
}

export const TaskPrioritySchema = z.nativeEnum(TaskPriority);
